export default function LoginSkeleton() {
  return (
    <>
      <style>{`
        @keyframes reactLoginSkeletonShimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: "100%",
          maxWidth: 110,
          height: "calc(1.2rem + 0.8rem + 2px)",
          padding: "0.4rem 0.9rem",
          borderRadius: "1.25rem",
          boxSizing: "border-box",
          background:
            "linear-gradient(90deg,#ececec 0%,#f7f7f7 50%,#ececec 100%)",
          backgroundSize: "200% 100%",
          animation: "reactLoginSkeletonShimmer 1.2s ease-in-out infinite",
          verticalAlign: "middle",
        }}
      />
    </>
  );
}
